{
  "unit": {
    "kwh": "kWh",
    "du": "kWh",
    "du_hint": ""
  },
  "fmt": {
    "less_than": "{{v}}未満",
    "approx": "約 {{v}}"
  },
  "cmp": {
    "flat": "横ばい",
    "more_pct": "{{pct}}% 増",
    "less_pct": "{{pct}}% 減",
    "more_abs": "{{v}} 増",
    "less_abs": "{{v}} 減",
    "why_prev_coverage": "前期同期間のデータ完全性が {{pct}}%（90% 未満）のため比較しません",
    "why_meters_changed": "前期と計測ポイントが異なるため比較しません",
    "why_prev_small": "前期が 1 kWh 未満のため差分で表示",
    "why_unavailable": "取得できないため比較しません",
    "why_no_prev": "前期のデータがないため比較しません",
    "why_btn": "比較しない理由"
  },
  "q": {
    "measured": "実測",
    "estimated": "推計",
    "incomplete": "データなし"
  },
  "chart": {
    "numbers": "数値を見る",
    "group": "{{title}}（左右キーで 1 つずつ移動）",
    "legend_bar": "実測",
    "legend_est": "推計",
    "legend_miss": "データなし（0 ではありません）",
    "legend_live": "進行中",
    "legend_zero": "実測 0",
    "col_time": "時間",
    "col_quality": "データ品質",
    "total": "合計",
    "prev_day": "前日",
    "next_day": "翌日",
    "prev_cell": "前へ",
    "next_cell": "次へ",
    "say_day": "{{label}}、{{v}}、{{q}}",
    "say_live": "{{label}}、{{v}}、進行中（{{time}} まで）",
    "say_miss": "{{label}}、データなし",
    "day_label": "{{m}} 月 {{d}} 日",
    "hour_label": "{{h}} 時",
    "month_label": "{{m}} 月",
    "tz_note": "{{tz}} で表示しています。日別合計は各$t(translation:leaf.cur)の現地日付で集計しています。"
  },
  "meter": {
    "poe_powered": "{{station}}・ポート {{port}} から給電",
    "port": "{{station}} ポート {{port}}",
    "port_of_home": "{{home}} {{station}} ポート {{port}}",
    "unmatched": "対応するデバイスなし"
  },
  "kind": {
    "plug": "プラグ",
    "poe": "PoE 給電",
    "meter": "電力計"
  },
  "title": "電力使用量",
  "subtitle": "電力を報告するデバイスの使用量と、おおよその電気代",
  "tab": {
    "overview": "概要",
    "ranking": "使用量ランキング",
    "report": "レポート"
  },
  "settings_btn": "電力設定",
  "settings_pick": "設定する$t(translation:leaf.cur)を選択",
  "no_access_page": "このページは電力データの閲覧権限がある人だけが開けます",
  "empty": "{{scope}}には電力を報告するデバイスがありません。対象：{{brand}}プラグ、PoE 給電の明細を報告する Kinio Station、{{brand}}ハブ経由の Matter プラグ / 電力計。",
  "empty_all": "すべてに切り替え",
  "load_err": "電力データを取得できません（{{reason}}）",
  "retry": "再試行",
  "partial_err": "一部の組織の電力データを取得できません。以下は取得できた分のみ集計しています",
  "mock_banner": "サンプルデータ：この環境にはまだ電力 API がないため、仮のデータを表示しています",
  "first_notice": "初めての方へ：電力データは閲覧権限のある人だけに表示されます。計測しているのはプラグ・PoE 給電・電力計で、$t(translation:leaf.cur)全体の使用量ではありません。",
  "dismiss": "OK",
  "period": {
    "month_to_date": "今月（今日まで）",
    "last_month": "先月",
    "today": "今日",
    "week": "今週（今日まで）",
    "year": "今年（今日まで）"
  },
  "need": {
    "title": "要対応",
    "count": "{{n}} 件",
    "count_shown": "{{n}} 件・{{shown}} 件を表示",
    "show_all": "全 {{n}} 件を見る",
    "plug_title": "{{home}}・{{name}}が過負荷のためオフになりました",
    "plug_rated": "{{time}} に {{w}} を使用し、プラグの上限 {{limit}} を超えました・現在 0 W",
    "plug_user": "{{time}} に {{w}} を使用し、設定した上限 {{limit}} を超えました・現在 0 W",
    "poe_title_high": "{{home}}・{{name}} の PoE 給電が異常しきい値（{{pct}}%）を超過",
    "poe_title_warn": "{{home}}・{{name}} の PoE 給電が注意しきい値（{{pct}}%）を超過",
    "poe_detail": "割当 {{alloc}} / {{rated}}（{{pct}}%）・実際 {{used}}",
    "poe_more_cam": "新しいカメラには給電されない可能性があります",
    "poe_incident": "この$t(translation:leaf.cur)は IT 監視が有効なため、インシデントを起票済みです",
    "home_unavailable": "{{home}}のデータを {{h}} 時間取得できていません（{{since}} から）",
    "home_unavailable_d": "Station とプラグがオフラインのため、この期間の使用量は集計に含まれていません",
    "gap_title": "{{n}} か所の計測ポイントで {{h}} 時間以上データを取得できていません",
    "gap_detail": "{{list}}。デバイスはオンラインですが、電力を報告していません",
    "gap_item": "{{home}} {{n}} か所",
    "act_device": "デバイスを見る",
    "act_incident": "インシデントを見る",
    "act_poe": "給電を見る",
    "act_home": "$t(translation:leaf.cur)を見る",
    "act_which": "対象を見る"
  },
  "card": {
    "energy": "今月の使用量（今日まで）",
    "energy_period": "{{period}}の使用量",
    "cmp_prev_month": "先月同期比",
    "cmp_prev": "前期同期比",
    "cmp_basis": "同じ {{homes}} か所の$t(translation:leaf.cur)・{{meters}} か所の計測ポイントで比較",
    "cmp_excluded": "{{list}}は比較対象外",
    "cmp_ex_new": "{{home}}（計測ポイント追加）",
    "cmp_ex_cov": "{{home}}（前期同期のデータが 90% 未満）",
    "cmp_ex_other": "{{home}}",
    "cmp_none": "比較なし：{{why}}",
    "incomplete": "{{meters}} か所の計測ポイントでデータが不完全です（計 {{hours}} 時間欠落）",
    "forecast": "月末見込み {{v}}",
    "cost": "推定電気代",
    "cost_homes": "{{n}} か所の$t(translation:leaf.cur)",
    "cost_more": "{{n}} 種類の通貨",
    "cost_note": "通貨ごとに表示（換算なし）・基本料金を含まず",
    "cost_disclaimer": "推定値です。請求や按分の根拠にはできません",
    "no_tariff": "{{n}} か所の$t(translation:leaf.cur)は電気料金が未設定のため含まれていません",
    "no_tariff_any": "電気料金が未設定",
    "set_tariff": "電気料金を設定",
    "carbon": "CO2排出量",
    "carbon_note": "{{region}}：{{provisional}}{{year}} 年 {{source}} 係数",
    "carbon_provisional": "暫定 ",
    "carbon_co2only": "（CO2 のみ）",
    "carbon_ref": "運用上の参考値",
    "poe_note": "PoE 給電量には Station 本体と電源変換損失は含まれません。",
    "visible_only": "電力を閲覧できる {{visible}} か所の$t(translation:leaf.cur)のみ集計（範囲内は計 {{total}} か所）",
    "unavailable_homes": "{{n}} か所の$t(translation:leaf.cur)は取得できないため含まれていません"
  },
  "trend": {
    "title_day": "推移・今日の時間別使用量",
    "title_month": "推移・日別使用量",
    "title_year": "推移・月別使用量",
    "day": "日",
    "month": "月",
    "year": "年",
    "granularity": "推移の期間",
    "by_kind": "種類別",
    "total_only": "合計",
    "compare": "$t(translation:leaf.cur)を比較…",
    "compare_n": "$t(translation:leaf.cur)を比較（{{n}}）",
    "compare_title": "比較する$t(translation:leaf.cur)を最大 5 か所選択",
    "compare_done": "比較",
    "compare_clear": "比較をやめる",
    "compare_max": "最大 5 か所",
    "daily_total": "日別合計",
    "today_live": "今日（進行中、{{time}} まで）"
  },
  "table": {
    "by_home": "$t(translation:leaf.cur)別",
    "by_org": "組織別",
    "sort_hint": "「先月比」の大きい順。比較できない行は「—」と表示し（選ぶと理由を表示）、末尾に並びます。",
    "sort_cmp": "先月比",
    "sort_energy": "使用量",
    "col_home": "$t(translation:leaf.cur)",
    "col_org": "組織",
    "col_kwh": "今月 kWh",
    "col_period_kwh": "今期 kWh",
    "col_cmp": "先月比",
    "col_cmp_period": "前期比",
    "col_daily": "1 日平均",
    "col_cost": "推定電気代",
    "col_meters": "計測ポイント",
    "col_unavail": "取得不可（計測ポイント）",
    "col_carbon": "CO2排出量",
    "no_tariff": "電気料金未設定",
    "more": "他 {{n}} か所の$t(translation:leaf.cur)",
    "show_all": "全 {{n}} 件を見る",
    "cross_currency": "通貨をまたいで並べ替えません",
    "homes_count": "{{n}} か所の$t(translation:leaf.cur)",
    "m2": "先月比 {{cmp}}・{{cost}}・取得不可の計測ポイント {{n}} か所",
    "m2_ok": "先月比 {{cmp}}・{{cost}}",
    "unavailable": "取得不可"
  },
  "ups": {
    "title": "UPS",
    "line_ok": "UPS {{n}} 台・すべて商用電源",
    "line_battery": "UPS {{n}} 台・{{b}} 台がバッテリー運転中・最短で残り {{rt}}",
    "line_battery_unk": "UPS {{n}} 台・{{b}} 台がバッテリー運転中・残り時間は取得不可",
    "unreadable": "{{n}} 台は取得不可",
    "minutes": "{{n}} 分",
    "note": "UPS の出力値は別のデバイス群の使用量のため、上の合計には含めません。",
    "go": "IT 監視で見る",
    "load_err": "UPS の状態を取得できません"
  },
  "rank": {
    "by_device": "デバイス別",
    "by_port": "PoE ポート別",
    "group": "集計方法",
    "kinds": "種類",
    "all_homes": "すべての$t(translation:leaf.cur)",
    "search": "デバイス・$t(translation:leaf.cur)を検索",
    "export": "CSV をエクスポート",
    "col_name": "名前",
    "col_kind": "種類",
    "col_kwh": "今期 kWh",
    "col_avg": "平均電力",
    "col_max": "最大電力",
    "col_cost": "推定電気代",
    "col_cmp": "前期比",
    "col_mode": "電力モード",
    "col_pick": "選択",
    "pick_all": "このページで変更できるカメラをすべて選択",
    "pick_row": "{{name}} を選択",
    "no_control": "このカメラの操作権限がないため電力モードを変更できません",
    "mode_changed": "{{date}} に「{{mode}}」へ変更",
    "mode_effect": "{{date}} に「{{mode}}」へ変更・変更前後 {{days}} 日の比較 {{cmp}}",
    "footer": "計測ポイント {{total}} か所中 {{from}}–{{to}} 位",
    "footer_filtered": "絞り込み「{{f}}」・計測ポイント {{total}} か所中 {{from}}–{{to}} 位",
    "next": "次のページ",
    "prev": "前のページ",
    "empty": "この期間の電力データはありません",
    "filters": "並べ替えと絞り込み",
    "close": "閉じる",
    "show": "{{n}} 件を表示",
    "sort": "並べ替え",
    "sort_kwh": "使用量の多い順",
    "sort_avg": "平均電力の高い順",
    "sort_max": "最大電力の高い順",
    "sort_cmp": "前期比の大きい順",
    "by_station": "{{home}}・{{station}}",
    "csv_name": "使用量ランキング"
  },
  "pm": {
    "0": "画質優先",
    "1": "バランス",
    "2": "省電力優先",
    "picked": "{{n}} 台のカメラを選択中",
    "why": "節約できるのは電気代です。PoE の割当はクラスで予約されるため、電力モードを変えても割当は下がりません。権限は 1 台ずつ確認します。",
    "clear": "選択解除",
    "set": "電力モードを設定…",
    "dlg_title": "{{n}} 台のカメラの電力モードを変更…",
    "dlg_saving": "節約できるのは電気代です：直近 7 日の実績から、月に約 {{v}} の削減が見込まれます",
    "dlg_alloc": "電力モードを変えても PoE の割当は下がりません。予算を空けるには、PoE クラスの低いカメラに替えるか、別の Station に分けてください。",
    "dlg_affects": "対象：{{names}}",
    "dlg_quality": "「省電力優先」では夜間の補助光と画質が下がる場合があります。",
    "dlg_ok": "{{n}} 台に適用",
    "dlg_cancel": "キャンセル",
    "result_title": "電力モードの結果",
    "result_summary": "{{applied}} 台適用済み、{{pending}} 台がデバイスでの適用待ち",
    "result_failed": "{{n}} 台は適用されませんでした",
    "st_applied": "✓ 適用済み",
    "st_pending": "⟳ デバイスでの適用待ち",
    "st_failed": "✕ デバイスが適用しませんでした",
    "st_forbidden": "✕ 操作権限なし",
    "deadline": "遅くとも {{time}} までに結果が出ます。それまでに適用されない場合は「デバイスが適用しませんでした」になります。",
    "retry": "再試行",
    "done": "完了",
    "err": "設定できませんでした：{{msg}}"
  },
  "report": {
    "month": "月",
    "month_opt": "{{y}} 年 {{m}} 月",
    "opt_provisional": "（暫定）",
    "opt_final": "（確定）",
    "provisional": "暫定：デバイスから後で届くデータにより数値が変わる可能性があります。{{date}} に確定します",
    "final": "確定",
    "date_md": "{{m}} 月 {{d}} 日",
    "scope_total": "範囲の合計",
    "gaps": "{{hours}} 時間欠落（計測ポイント {{meters}} か所）",
    "no_gaps": "欠落なし",
    "summary_by": "$t(translation:leaf.cur)別の概要",
    "only_gaps": "欠落ありのみ（{{n}}）",
    "has_gap": "! 欠落あり",
    "expand": "{{home}} の計測ポイントを表示",
    "top": "上位 10 件",
    "rounding": "各行は四捨五入表示、合計は丸め前の値で計算（CSV は小数第 2 位まで）",
    "csv_homes": "CSV をダウンロード（$t(translation:leaf.cur)×日）",
    "csv_meters": "CSV をダウンロード（計測ポイント×月）",
    "csv_prefix": "電力",
    "provisional_tag": "暫定",
    "carbon_basis": "{{gas}}・{{year}} 年係数",
    "pdf_later": "PDF と毎月の送付は今後対応予定です"
  },
  "csv": {
    "disclaimer": "推定値です。請求や按分の根拠にはできません",
    "date": "日付",
    "month": "月",
    "home": "$t(translation:leaf.cur)",
    "org": "組織",
    "meter_name": "計測ポイント",
    "meter_kind": "種類",
    "kwh": "使用量（kWh）",
    "avg_w": "平均電力（W）",
    "max_w": "最大電力（W）",
    "cost": "推定電気代（{{cur}}）",
    "currency": "通貨",
    "cost_amount": "推定電気代",
    "quality": "データ品質（実測 / 推計 / データなし）",
    "missing_h": "欠落時間",
    "carbon": "CO2排出量（kg）",
    "carbon_basis": "CO2排出量の算定基準"
  },
  "org": {
    "card_title": "電気料金と CO2排出量",
    "card_hint": "{{n}} 件の料金プラン・$t(translation:leaf.cur)に適用すると電気代を推定できます",
    "manage": "電気料金を管理",
    "title": "電気料金",
    "crumb": "組織設定",
    "hint": "$t(translation:leaf.cur)に料金プランを適用すると、電力使用量ページで電気代を推定できます。同じ料金の$t(translation:leaf.cur)は〔$t(translation:leaf.cur)に適用…〕で 1 つのプランにまとめ、以後は 1 つだけ管理するのがおすすめです。名前と履歴を残したいときだけ〔新しいバージョンに切り替え…〕を使ってください。",
    "no_admin": "電気料金を管理できるのは組織のオーナーか管理者だけです",
    "col_name": "プラン",
    "col_kind": "種類",
    "col_currency": "通貨",
    "col_applied": "適用先",
    "col_version": "現在のバージョン",
    "applied_n": "{{n}} か所の$t(translation:leaf.cur)",
    "version_from": "v{{v}}・{{date}} から",
    "kind_flat": "単一料金",
    "kind_tiered": "段階料金",
    "kind_tou": "時間帯別料金",
    "add": "プランを追加",
    "apply": "$t(translation:leaf.cur)に適用…",
    "new_version": "新しいバージョンに切り替え…",
    "delete": "削除",
    "delete_confirm": "「{{name}}」を削除しますか？",
    "in_use": "まだ {{n}} か所の$t(translation:leaf.cur)がこのプランを使っています。削除する前に、別のプランへ移してください",
    "empty": "料金プランはまだありません",
    "carbon_title": "CO2排出量",
    "show_carbon": "電力使用量の概要に CO2排出量カードを表示",
    "carbon_category": "排出係数の区分",
    "cat_grid": "電力系統の平均（地域・年度別）",
    "saved": "✓ 保存しました",
    "recalc": "再計算中（約 1 分）",
    "no_rates": "単価は表示できません（$t(translation:leaf.cur)のオーナー・管理者と組織管理者のみ表示できます）"
  },
  "ed": {
    "title": "料金プランを追加",
    "from_template": "テンプレートから",
    "custom": "カスタム",
    "template": "テンプレート",
    "template_note": "テンプレートの単価は公式発表に基づきます（登録前に原文と照合しています）。画面の数値は出発点なので、編集できます。",
    "name": "プラン名",
    "kind": "種類",
    "currency": "通貨",
    "effective": "適用開始日",
    "effective_hint": "既定は今月 1 日。遡りは 30 日まで。確定済みの月は再計算しません",
    "flat_price": "1 kWh あたりの単価",
    "tier": "第 {{n}} 段",
    "tier_upto": "月 {{v}} kWh まで",
    "tier_rest": "それ以上",
    "tou_period": "{{name}}（{{days}} {{from}}–{{to}} 時）",
    "days_weekday": "月〜金",
    "days_weekend": "週末・祝日",
    "days_all": "毎日",
    "per_kwh": "{{cur}} / kWh",
    "save": "プランを作成",
    "cancel": "キャンセル",
    "err_name": "プラン名は必須です",
    "err_price": "単価は 0 以上の数値にしてください",
    "version_title": "「{{name}}」の新しいバージョン",
    "version_save": "バージョンを追加"
  },
  "apply": {
    "title": "「{{name}}」を$t(translation:leaf.cur)に適用",
    "filter_old": "旧プラン利用中（{{n}}）",
    "filter_none": "電気料金未設定（{{n}}）",
    "filter_all": "すべて（{{n}}）",
    "shown": "{{n}} か所の$t(translation:leaf.cur)を表示",
    "hidden": "他 {{n}} か所は条件外",
    "clear_filter": "絞り込みを解除",
    "current": "現在：{{name}}",
    "current_none": "現在：電気料金未設定",
    "already": "すでにこのプランです",
    "currency_diff": "通貨が異なるため（{{cur}}）適用できません",
    "pick_all": "「{{group}}」をすべて選択",
    "next": "{{n}} か所の$t(translation:leaf.cur)に適用…",
    "confirm_title": "「{{name}}」を {{n}} か所の$t(translation:leaf.cur)に適用",
    "confirm_body": "この {{n}} か所の$t(translation:leaf.cur)の {{date}} 以降の推定電気代を新しいプランで再計算します。ダウンロード済みのレポートは変わりません。",
    "confirm_old": "うち {{n}} か所は「{{old}}」を使っていました。",
    "final_warn": "{{month}} は確定済みのため再計算しません",
    "ok": "適用",
    "done": "{{n}} か所の$t(translation:leaf.cur)に適用しました",
    "done_one": "適用しました",
    "undo": "元に戻す",
    "none_picked": "適用する$t(translation:leaf.cur)を選んでください"
  },
  "leaf": {
    "title": "電力設定",
    "crumb_sites": "組織と拠点",
    "locked": "変更できるのはオーナーか管理者だけです",
    "tariff": "電気料金",
    "tariff_org": "組織のプランを使用：{{name}}",
    "tariff_home": "{{name}}（この$t(translation:leaf.cur)独自）",
    "tariff_none": "電気料金が未設定",
    "tariff_pick": "変更",
    "tariff_none_opt": "電気料金を設定しない（電気代に含めない）",
    "tariff_custom": "カスタム…（組織設定 › 電気料金）",
    "alerts": "電力アラート",
    "poe": "PoE 給電",
    "poe_desc": "Station の定格に対する割合がこの値を超えたら通知",
    "poe_warn": "注意",
    "poe_high": "異常",
    "pct": "%",
    "gap": "データ取得不可",
    "gap_desc": "オンラインのデバイスがこの時間以上電力を報告しない場合に通知",
    "hours": "時間",
    "kmgr_on": "この$t(translation:leaf.cur)は IT 監視が有効です。しきい値を超えるとインシデントを起票し、当番表に沿って通知します",
    "kmgr_off": "しきい値を超えると、$t(translation:leaf.cur)のオーナーと管理者に通知します（受信箱のみ）",
    "managed": "テンプレート「{{name}}」で管理",
    "unmanage": "テンプレート管理を解除",
    "unmanage_confirm": "解除するとここでしきい値を変更でき、今後のテンプレート変更はこの$t(translation:leaf.cur)に適用されません。",
    "saved": "✓ 保存しました",
    "saving": "保存中…",
    "err_range": "{{min}}〜{{max}} の整数にしてください",
    "err_order": "注意しきい値は異常しきい値以下にしてください",
    "pick_title": "$t(translation:leaf.cur)を選択",
    "not_found": "この$t(translation:leaf.cur)が見つからないか、権限がありません",
    "to_overview": "この$t(translation:leaf.cur)の電力使用量を見る"
  },
  "dev": {
    "title": "電力使用量",
    "now": "現在",
    "today": "今日",
    "month": "今月（今日まで）",
    "cost": "推定電気代",
    "via_poe": "PoE 給電で計測（{{station}} ポート {{port}}）",
    "range_day": "日",
    "range_week": "週",
    "range_month": "月",
    "chart_day": "直近 24 時間の時間別使用量",
    "chart_week": "直近 7 日の日別使用量",
    "chart_month": "直近 30 日の日別使用量",
    "export": "CSV をエクスポート",
    "no_data": "電力データはまだありません",
    "load_err": "電力データを取得できません",
    "mode_mark": "{{date}} に「{{mode}}」へ変更"
  },
  "stn": {
    "budget": "PoE 給電：割当 {{alloc}} / {{rated}}・実際 {{used}}",
    "budget_norated": "PoE 給電：現在の給電 {{used}}",
    "alloc_note": "割当が実際より {{diff}} 多くなっています。PoE はクラスごとに予約されるため、カメラの電力モードを変えても下がるのは電気代だけで、割当は下がりません。",
    "col_today": "今日",
    "col_24h": "24 時間",
    "today": "今日 {{v}}",
    "spark": "ポート {{port}} の直近 24 時間の給電",
    "expand": "ポート {{port}} の 7 日間の推移を見る",
    "collapse": "閉じる",
    "week_title": "ポート {{port}}・直近 7 日の時間別給電",
    "no_detail": "この Station は PoE 給電の明細を報告していません",
    "load_err": "給電データを取得できません",
    "unknown": "不明",
    "budget_noalloc": "PoE 給電：定格 {{rated}}・実際 {{used}}",
    "col_energy": "電力使用量"
  },
  "syn": {
    "energy": "電力,電気代,料金,電力量,kWh,CO2,PoE,消費電力,省電力,使用量",
    "org_tariffs": "電気料金,単価,排出係数",
    "leaf_settings": "電力設定,電力アラート,PoE しきい値",
    "ups": "UPS,無停電電源,無停電電源装置,停電,バッテリー,PoE"
  },
  "search": {
    "leaf_settings": "$t(translation:leaf.cur)の電力設定（先に$t(translation:leaf.cur)を選択）",
    "ups": "ネットワークとアプリ・UPS"
  },
  "err": {
    "ENERGY_RANGE_TOO_LARGE": "期間が長すぎます。短くしてからもう一度お試しください",
    "ENERGY_TARIFF_INVALID": "料金プランが正しくありません：{{reason}}",
    "ENERGY_TARIFF_IN_USE": "まだこのプランを使っている$t(translation:leaf.cur)があります",
    "FORBIDDEN": "権限がありません",
    "VERSION_CONFLICT": "他の人が変更しました。再読み込みしてから変更してください",
    "NOT_FOUND": "電力サービスにまだこのデータがありません",
    "other": "エラーが発生しました（{{code}}）",
    "copy": "サポート用にコピー",
    "details": "詳細"
  },
  "loading": "読み込み中…"
}
